module.exports = __webpack_public_path__ + "static/17-96d0cbcbee5fd512050fc7365ebc5553.jpg";